var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgH = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "5.25rem",
  height: "5.25rem",
  "data-name": "Group 18",
  viewBox: "0 0 200 191.107"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "H_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h200v191.107H0z",
  "data-name": "Rectangle 23"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 17",
  style: {
    clipPath: "url(#H_svg__a)"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M158.824 119.218a9.43 9.43 0 0 0-2.657 8.214l9.059 52.785A9.229 9.229 0 0 1 151.818 190l-47.47-24.882a9.24 9.24 0 0 0-8.7 0L48.183 190a9.229 9.229 0 0 1-13.409-9.783l9.06-52.785a9.43 9.43 0 0 0-2.657-8.214L2.766 81.774A9.313 9.313 0 0 1 7.96 65.951l53.026-7.61a9.57 9.57 0 0 0 7-5.073l23.68-48.074a9.284 9.284 0 0 1 16.669 0l23.674 48.074a9.58 9.58 0 0 0 7.006 5.073l53.026 7.61a9.313 9.313 0 0 1 5.194 15.823z",
  "data-name": "Path 9"
}))));
export default SvgH;